export default __webpack_public_path__ + "9806da5cca58f6718cd28ceb7896e738.png";